module.exports = {"433127101":"首车镇","433127103":"芙蓉镇","433127104":"永茂镇","433127108":"小溪镇","433127109":"青坪镇","433127112":"石堤镇","433127113":"万坪镇","433127114":"塔卧镇","433127115":"砂坝镇","433127116":"灵溪镇","433127117":"松柏镇","433127118":"泽家镇","433127200":"两岔乡","433127202":"西歧乡","433127203":"对山乡","433127210":"高坪乡","433127216":"朗溪乡","433127220":"润雅乡","433127222":"车坪乡","433127228":"毛坝乡","433127229":"万民乡","433127230":"盐井乡","433127238":"颗砂乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/433127.json
// module id = 2067
// module chunks = 0